import { render } from "./LabsByType.vue?vue&type=template&id=300a214e"
import script from "./LabsByType.vue?vue&type=script&lang=js"
export * from "./LabsByType.vue?vue&type=script&lang=js"
script.render = render

export default script